<wa-dialog label="select staff members" open="true" lightDismiss=false withoutHeader=true withFooter="true">
  <div class="wa-stack">
    <h3 class="wa-heading-m">Create survey</h3>
    <app-survey-properties
      (inputEvent)="properties=$event">
    </app-survey-properties>
    <app-upload
      (selectedEvent)="selectedFile=$event">
    </app-upload>
  </div>
  <div slot="footer">
    <div class="wa-cluster">
      <wa-button variant="neutral" appearance="filled" (click)="cancel()">Cancel</wa-button>
      @if (!processing) {
        @if (uploadValid()) {
          <wa-button
            variant="brand"
            (click)="submit()">
            upload file
          </wa-button>
        } @else if (createNewSurveyValid()) {
          <wa-button
            variant="brand"
            (click)="submit()">
            create empty survey
          </wa-button>
        } @else {
          <wa-button
            variant="brand"
            [disabled]="true"
            (click)="submit()">
            upload / create
          </wa-button>
        }
      } @else {
        <wa-button
          variant="brand"
          [disabled]="true"
          (click)="submit()">
          <wa-icon name="spinner-third" class="fa-spin"></wa-icon>
        </wa-button>
      }
    </div>
  </div>
</wa-dialog>
